/**
 * Shared Mock Stores — 统一跨模块共享的 mock 数据存储
 * 
 * 解决 processing.ts 和 traceCode.ts 各自维护独立 ordersStore 副本的问题。
 * 所有 mock handler 模块应从此文件导入共享的 store 引用。
 */
import { mockOrders as processingMockOrders } from '../fixtures/processing';

// 统一的订单数据存储 — 所有模块共享同一个引用
export const sharedStores = {
  orders: [...processingMockOrders] as any[],
};

/**
 * 获取当前的共享订单列表引用（用于读取）
 */
export function getOrdersStore(): any[] {
  return sharedStores.orders;
}

/**
 * 更新共享订单列表（用于写入：添加/删除/修改后需要回写）
 */
export function setOrdersStore(newOrders: any[]): void {
  sharedStores.orders = newOrders;
}
